import { pathOr } from "ramda"

export const leadStatus = (policy) => {
    if (pathOr("", ['assignments', '0', 'status'], policy) === 'rejected') {
        return "Rejected"
    }
    if (policy.journeyStatus === 'assigned') {
        return "Completed"
    } else if (policy.journeyStatus === 'document verified') {
        return "Document Verified"
    }
    else if (policy.journeyStatus === 'approval pending') {
        return "Approval Pending"
    } else if (pathOr(false, ["assignments", "0", "isSigned"], policy)) {
        return "eSign Completed"
    }
    else if (pathOr("", ["assignments", "0", "agreementLink"], policy) != "" && !pathOr(false, ["assignments", "0", "isSigned"], policy) && policy.journeyStatus == 'esign') {
        return "eSign Pending"
    } else if (policy.journeyStatus == 'bank verified') {
        return "Bank Verified"
    } else if (policy.journeyStatus === 'kyc') {
        return "KYC Inprogress"
    } else if (policy.smsSent) {
        return "SMS Sent"
    } else {
        return "New Lead"
    }
}

export const leadStatusNum = (policy) => {
    if (policy.journeyStatus === 'assigned') {
        return 9
    } else if (policy.journeyStatus === 'document verified') {
        return 8
    }
    else if (policy.journeyStatus === 'approval pending') {
        return 7
    } else if (pathOr(false, ["assignments", "0", "isSigned"], policy)) {
        return 6
    }
    else if (pathOr("", ["assignments", "0", "agreementLink"], policy) != "" && !pathOr(false, ["assignments", "0", "isSigned"], policy) && policy.journeyStatus == 'esign') {
        return 5
    } else if (policy.journeyStatus == 'bank verified') {
        return 4
    } else if (policy.journeyStatus === 'kyc') {
        return 3
    } else if (policy.smsSent) {
        return 2
    } else if (pathOr("", ['assignments', '0', 'status'], policy) === 'rejected') {
        return 0
    } else {
        return 1
    }
}